export default __webpack_public_path__ + "static/power_media_4-eba67772a42e3a08d6156f69ab12d79c.webp";